import React, { useState, useEffect, useContext, useCallback } from 'react';
import { useHistory, useLocation } from "react-router-dom";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import { Grid, MenuItem } from '@material-ui/core';
import { toast } from "react-toastify";
import { CSVLink } from "react-csv";
import * as moment from "moment";
import access from 'config/access';
import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

import {
  loginValidate,
  signupDetailsValidate,
} from 'helpers/validateRules/auth';
import useForm from '../../../helpers/useForm';
import { styles } from './styles';
import createNewAdmin from 'apis/createNewAdmin/createNewAdmin';
import Loader from 'components/Loader/Loader';
import Context from 'context/context';
import Table from 'components/Table/Table';
import { exportHeaders } from "./export";
import useDebounce from "helpers/useDebounce";
import searchIcon from "assets/img/Search_Icon.png";

// material-ui icons
import VisibilityOffOutlinedIcon from '@material-ui/icons/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import audit from "apis/audit/audit";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import HistoryIcon from "@material-ui/icons/History";
import HistoryTable from "components/Table/History/HistoryTable";
import role from "apis/role/role";




// custom TextField
const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      background: 'transparent',
    },
    '& .MuiFormLabel-root': {
      background: 'transparent',
    },
    '& .MuiInputBase-input': {
      background: 'transparent',
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: '#000 !important',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#000 !important',
    },
  },
})(TextField);

const initialValues = {
  firstName: '',
  lastName: '',
  email: '',
  role: '',
  password: '',
  
};

// const { state} = useContext(Context);







const headings = ['SNo', 'First Name', 'Last Name', 'Email', 'Role', 'View Detail',"History"];

function CreateNewAdmin() {
  const history = useHistory();
  const location = useLocation();
  const { getAudit,getAudituser } = audit();
  const { state, dispatch } = useContext(Context);
  const {
    values,
    errors,
    handleSubmit,
    setErrors,
    handleChange,
    setUpdateValue,
    resetForm
  } = useForm(initialValues, handleCreate, signupDetailsValidate);
  const { getAllAdmins, create, allAdminExport,search } = createNewAdmin();
  const classes = styles();
  const [open, setOpen] = useState(false);
  const [states, setstates] = useState({
    showPassword: false,
    tooltipName: '',
    tooltipCondition: false,
    disableButton: false,
    historyLoader: false,
  });
  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const { t, i18n } = useTranslation();
  const [searchValue, setSearchValue] = useState("");
  const searchBounceValues = useDebounce(searchValue);
  const [isLoading, setIsLoading] = useState(false);
  const [exportData, setExportData] = useState([]);
  const { historyLoader } = states;
  const {  getRoleList } = role();
const[roleList,setrolelist]= useState([])
  

  useEffect(() => {
    handleGetAllAdmins();
    handleGetRoles();
  }, [offset]);

//   const roles = [
//     {
//         id: 3,
//         name: 'Program Admin',
//     },
//     {
//         id: 10,
//         name: 'IT Admin'
//     },
//     {
//         id: 9,
//         name: 'Accounting'
//     },
//     {
//         id: 12,
//         name: 'Observer'
//     },

//     {
//       id: 13,
//       name: 'Super Admin'
//   }
// ]

const handleGetRoles = async () => {
  setStates({
    roleList:[]
  })
  try {
    dispatch({ type: 'SET_LOADING', payload: true });      
    let res = await getRoleList();
    if (res) {
      setrolelist( res?.data)
    }
    dispatch({ type: 'SET_LOADING', payload: false })
  }
  catch (e) {
    console.log({ e });
  }
};






  let rolesdrop

if (state?.userInfo?.role_id !== 10){

  rolesdrop = roleList.filter(item => item.role_id !== 10 && item.role_id !== 13);
}
else{
  rolesdrop =  roleList

}

console.log()

  // handling search api
  useEffect(() => {
    let offsetValue = location?.state?.offset;
    if (searchBounceValues && searchBounceValues.length > 0) {
      handleSearch();
    } 
    else if (offsetValue) {
      setOffset(offsetValue);
      location.state = undefined;
    } 
    else {
      setOffset(1);
    }
  }, [searchBounceValues]);

  async function handleGetAllAdmins() {
    try {
      dispatch({ type: 'SET_LOADING', payload: true });
      let values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };
      let res = await getAllAdmins(values);
      setData(res.data);
      setCount(res.count);
      dispatch({ type: 'SET_LOADING', payload: false });
    } 
    catch (e) {
      console.log({ e });
    }
  }

//   let rolestable

// if (state?.userInfo?.role_id !== 10){

//   rolestable = data.filter(item => item['HS_Role.role_name'] !== 'IT Admin' && item['HS_Role.role_name'] !== 'Super Admin');
// }
// else{
//   rolestable =  data

// }

  const handleClickOpen = () => {
    setOpen(true);
  };



  // search api func
  const handleSearch = async () => {
    setStates({
      salesCategory: "",
      redemptionFrom: null,
      redemptionTo: null,
      orgName: "",
      filter: false,
      isActive: "",
    });
  
    try {
      let values = {
        searchValue: searchValue,
        offset: (offset - 1) * 10,
        limit: 10,
      };
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await search(values);
      dispatch({ type: "SET_LOADING", payload: false });
      if (res) {
        setData(res.data);
        setCount(res.count);
        return;
      }
      setData([]);
    } 
    catch (e) {
      dispatch({ type: "SET_LOADING", payload: false });
      console.log({ e });
    }
  };

  function reset() {
    handleChange({ name: 'firstName', value: '' });
    handleChange({ name: 'lastName', value: '' });
    handleChange({ name: 'email', value: '' });
    handleChange({ name: 'role', value: '' });
    handleChange({ name: 'password', value: '' });
  }

  const handleClose = () => {
    reset();
     resetForm();
    setOpen(false);
  };

  async function handleCreate() {
    try {
      values.loginuser = state?.userInfo.role_id;
      dispatch({ type: 'SET_LOADING', payload: true });
      let res = await create(values);
      dispatch({ type: 'SET_LOADING', payload: false });
      handleClose();
      if (res.status_code == 200 && res?.type?.toLowerCase()!=="error" ) {
        toast.success(res?.message, { toastId: 'create-admin' });
        handleGetAllAdmins();
      } 
      else {
        toast.error(res?.message, { toastId: 'create-admin' });

      }
     
    } 
    catch (e) {
      console.log({ e });
      handleGetAllAdmins();
    }
  }
  const handleGetHistoryData = async (id) => {
    try {
      let values;
      values = {
        recordId: id,
        key: "user",
      };
      let res = await getAudituser(values);
      if (res) {
        setStates({ historyData: res?.data, historyLoader: false });
      }
    } 
    catch (e) {
      console.log({ e });
    }
  };
  // change pagination func
  const handlePagination = (value) => {
    setOffset(value);
  };

  // export api function
  const handleExport = async () => {
    let values = {};
    if (searchValue) {
    values = { ...values, searchValue };
    }
   
    if (states.orgName) {
    values = { ...values, orgName: states.orgName };
    }
       dispatch({ type: "SET_LOADING", payload: true });
    setIsLoading(true);
    let res = await allAdminExport(values);
    if (res && res.data) {
    setExportData(res.data);
    dispatch({ type: "SET_LOADING", payload: false });
    setIsLoading(false);
    if (res.data.length === 0) {
        toast.success(t("No Data Found"), { toastId: "no-report-date" });
        return false;
    }
    return true;
    }
  };

  const invalidChar = ['~', '`', '!', '#', '$', '%', '^', '*', '(', ')', '_', '+', '=', '', ';', ':', '<', '.', '>', '?', '|', '[', ']', '{', '}', '"', "'"]
  const blockInvalidChar = e => invalidChar.includes(e.key) && e.preventDefault();
  // console.log(states.historyLoader,'raja')
  return (
    <>
      <div>
        <div className={classes.btnDiv}>
        <Grid item xs={12} style={{ display: "flex", alignItems: "center" }}>
            <div style={{ flex: 0.99 }}>
                <CssTextField
                    placeholder="Search for email"
                    type={"text"}
                    variant="outlined"
                    onKeyDown={blockInvalidChar}
                    className={classes.searchInput}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                {searchValue.length > 0 ? (
                                    <CloseOutlinedIcon
                                        className={classes.searchInputIcon}
                                        onClick={() => {
                                            setSearchValue("");
                                            setOffset(1);
                                            handleGetAllAdmins();
                                        }}
                                    />
                                ) : (
                                    <img
                                        src={searchIcon}
                                        alt=""
                                        width="20px"
                                        className={classes.searchInputIcon}
                                    />
                                )}
                            </InputAdornment>
                        ),
                    }}
                    value={searchValue}
                    onChange={(e) => {
                        setSearchValue(e.target.value);
                        setOffset(1);
                        if (e.target.value.length == 0) {
                            handleGetAllAdmins();
                        }
                    }}
                    onClick={() => {
                        setOffset(offset);
                    }}
                />                            
            </div>
            <CSVLink
                id="csv"
                data={exportData}
                headers={exportHeaders.map((head) => head)}
                filename={"UserAccount"+moment(new Date()).format("MM-DD-YYYY,h:mm A")+".csv"}
                className={classes.CSVlink}
            />
            <button
                disabled={isLoading}
                className={classes.exportBtn}
                onClick={async () => {
                let res = await handleExport();
                    if (res) {
                        document.getElementById("csv").click();
                    }
                }}
            >
                Export
            </button>
            {(state?.userInfo?.role_id == 10 || state?.userInfo?.role_id == 13) ?(
            <button className={classes.createBtn} onClick={handleClickOpen}>
              {t('Create')}
            </button> 
            ):
            <></>  
}          
        </Grid>
          
        </div>
        <Loader Loading={state.loading} top={'35%'}>
          <div className={classes.responsiveTable}>
            <Grid item xs={12} sm={12} lg={12}>
              <Table
                headings={headings} //.map(i => <div>{i}</div>)}
                data={data.map((p, i) => [
                  ((offset - 1) * 10) + (i + 1),
                  [p?.first_name],
                  [p?.last_name],
                  [p?.email],
                  [p['HS_Role.role_name']],
                  [
                    <RemoveRedEyeIcon
                      key={i}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        history.push("/dashboard/create-new-admin-detail", {
                            allAdminId: p?.user_id,
                          offset,
                        });
                      }}
                    />,
                  ],
                  [
                    <HistoryIcon
                      key={i}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setStates({
                          historyDialog: true,
                          historyLoader: true,
                        });
                        handleGetHistoryData(p?.user_id);
                      }}
                    />
                  ],
                ])}
                offset={offset}
                count={
                  (count / 10) % 1 == 0
                    ? Math.floor(count / 10)
                    : Math.floor(count / 10 + 1)
                }
                handlePagination={handlePagination}
              />
            </Grid>
          </div>
        </Loader>
      </div>
      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        aria-describedby='alert-dialog-slide-description'
        fullWidth
        maxWidth='xs'
        disableBackdropClick
      >
        <DialogTitle></DialogTitle>
        <DialogContent>
          <CloseOutlinedIcon
            className={classes.closeIcon}
            onClick={handleClose}
          />
          <div
            style={{
              fontSize: 20,
              fontWeight: 'bold',
              textAlign: 'center',
            }}
          >
            {t('Create New Account')}
          </div>          
          <DialogContentText id='alert-dialog-slide-description'>
            <Grid
              container
              item
              xs={12}
              spacing={Object.keys(errors).length > 2 ? 0 : 2}
            >
              <Grid item xs={12}>
                <CssTextField
                  id='firstName'
                  label={t('First Name')}
                  type={'text'}
                  onfocus="this.removeAttribute('readonly')"
                  value={values.firstName}
                  fullWidth
                  onChange={(e) => {
                    handleChange({ name: 'firstName', value: e.target.value });
                  }}
                />
                      {!values.firstName && errors.firstName && (
          <span
            style={{
              color: "red",
              fontSize: "12px",
              display: "block",
              marginTop: "4px",
            }}
          >
            {errors.firstName}
          </span>
        )}
              </Grid>
              <Grid item xs={12}>
                <CssTextField
                  id='lastName'
                  label={t('Last Name')}
                  type={'text'}
                  fullWidth
                  onfocus="this.removeAttribute('readonly')"
                  value={values.lastName}
                  onChange={(e) => {
                    handleChange({ name: 'lastName', value: e.target.value });
                  }}
                />
                        {!values.lastName && errors.lastName && (
                      <span
                        style={{
                          color: "red",
                          fontSize: "12px",
                          display: "block",
                          marginTop: "4px",
                        }}
                      >
                        {errors.lastName}
                      </span>
                    )}
              </Grid>

             
              <Grid item xs={12}>
                <CssTextField
                  id='email'
                  label={t('Email')}
                  type={'email'}
                  fullWidth
                  onfocus="this.removeAttribute('readonly')"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='end'>
                        <IconButton edge='end'>
                          <EmailOutlinedIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  value={values.email}
                  onChange={(e) => {
                    const value = e.target.value;
                    handleChange({ name: 'email', value });
                  }}
                />
                
                  {(values.email && state?.userInfo?.loyalty_organization_name === 'Henry Schein Dental') &&
                    !/^[\w.%+-]+@henryschein\.com$/i.test(values.email) && (
                      <span style={{ color: 'red', fontSize: '0.8rem' }}>
                        Only henryschein.com email is allowed
                      </span>
                  )}

                    {(values.email && state?.userInfo?.loyalty_organization_name === 'Henry Schein Canada') &&
                    !/^[\w.%+-]+@henryschein\.ca$/i.test(values.email) && (
                      <span style={{ color: 'red', fontSize: '0.8rem' }}>
                        Only henryschein.ca email is allowed
                      </span>
                  )}
               
                {!values.email && errors.email && (
                      <span
                        style={{
                          color: "red",
                          fontSize: "12px",
                          display: "block",
                          marginTop: "4px",
                        }}
                      >
                        {errors.email}
                      </span>
                    )}
              </Grid>
              <Grid item xs={12}>
                <CssTextField
                  id='role'
                  label={t('Role')}
                  select
                  fullWidth
                   value={values.role}
                  onfocus="this.removeAttribute('readonly')"
                  onChange={(e) => {
                    handleChange({ name: 'role', value: e.target.value });
                  }}
                >
                  {rolesdrop.filter(item=>item.is_cdr_admin == true).map((item) => {
                    return (
                      <MenuItem key={t(item.role_name)} value={item.role_id}>
                        {t(item.role_name)}
                      </MenuItem>
                    );
                  })}
                </CssTextField>
                {!values.role && errors.role && (
                      <span
                        style={{
                          color: "red",
                          fontSize: "12px",
                          display: "block",
                          marginTop: "4px",
                        }}
                      >
                        {errors.role}
                      </span>
                    )}
              </Grid>
              { state?.userInfo?.role_id !== 13 && state?.userInfo?.role_id !== 10 ? (
              <Grid item xs={12}>
                <CssTextField
                  id='pd'
                  label={t('Password')}
                  type={states.showPassword ? 'text' : 'password'}
                  autoComplete='new-password'
                  fullWidth
                  onfocus="this.removeAttribute('readonly')"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='end'>
                        <IconButton
                          aria-label='toggle password visibility'
                          onClick={() => {
                            setStates({ showPassword: !states.showPassword });
                          }}
                          edge='end'
                        >
                          {states.showPassword ? (
                            <VisibilityOutlinedIcon
                              className={classes.passwordInputIconBtn}
                            />
                          ) : (
                            <VisibilityOffOutlinedIcon
                              className={classes.passwordInputIcon}
                            />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  value={values.password}
                  onChange={(e) => {
                    handleChange({ name: 'password', value: e.target.value });
                  }}
                />
                {errors?.password && (
                  <span className={classes.errorMsg}>{errors?.password}</span>
                )}
              </Grid>
              ):null }
            </Grid>
            <div className={classes.popupBtnDiv}>
              <button className={classes.submitBtn} onClick={handleSubmit}>
                {!state.loading ? t('Submit') : `${t('Please wait')}..`}
              </button>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={states.historyDialog ? true : false}
        style={{ fontFamily: "Segoe-ui" }}
        maxWidth={false}
      >
        <div className={classes.dialogParentDiv}>
          <div
            className={classes.parentText}
            style={{
              paddingBottom: 10,
              width: states?.historyData?.length > 0 ? "100%" : 300,
            }}
          >
            {t('History')}
            <span style={{ float: "right" }}>
              <HighlightOffIcon
                style={{
                  cursor: "pointer",
                  color: "red",
                  fontSize: 35,
                }}
                onClick={() => {
                  setStates({ historyDialog: false, historyData: [] });
                }}
              />
            </span>
          </div>

          {!historyLoader ? (
            <HistoryTable
              headings={[
                "Date of Change",
                "Updated by",
                "Column Name",
                "Description",
              ]}
              data={
                states?.historyData?.length > 0 &&
                states?.historyData.map((d, i) => [
                  d?.created_at
                    ? `${moment(d?.created_at).format("YYYY-MM-DD HH:mm:ss")}`
                    : "",
                  `${d?.["User.email"]
                    ? d?.["User.email"]
                    : d?.altered_by
                      ? d?.altered_by.charAt(0).toUpperCase() +
                      d?.altered_by.slice(1).toLowerCase()
                      : "-"
                  }`,
                  d?.column_name,
                  `"${d?.old_value}" changed to "${d?.new_value}"`,
                ])
              }
              disablePagination={true}
            />
          ) : (
            <div>
              <Loader Loading={historyLoader} top={"15%"}></Loader>
            </div>
          )}
        </div>
      </Dialog>
    </>
  );
}

export default CreateNewAdmin;
